var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99962 16.7389L5.34587 12.9889L1.72087 9.23886C-0.240291 7.16635 -0.240291 3.92262 1.72087 1.85011C2.68117 0.927187 3.98185 0.444892 5.31171 0.518615C6.64157 0.592338 7.88097 1.21545 8.73337 2.23886L8.99962 2.50011L9.26337 2.22761C10.1158 1.2042 11.3552 0.581088 12.685 0.507365C14.0149 0.433642 15.3156 0.915937 16.2759 1.83886C18.237 3.91137 18.237 7.1551 16.2759 9.22761L12.6509 12.9776L8.99962 16.7389Z",
    fill: "black",
    fillOpacity: 0.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a79dc3c40a48e7f475efadaad83169f5.svg";
export { ForwardRef as ReactComponent };